import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, reduxForm, getFormValues } from 'redux-form';
import { actions as channelActions } from '../../../channel/redux/channelActions';
import { actions } from '../../redux/brokerActions';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import { Col, Row, ControlLabel, Alert } from 'react-bootstrap';
import { InfoLabel, SimpleModal, Button } from '../../../../common/components';
import { InternalButtonBar } from '../../../layout/components';
import UploadCropComponent from '../../../../common/components/Upload/UploadCrop';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { triggerFileUpload } from '../../../../common/components/Upload/UploadRedux';
import { Link } from 'react-router';
import ReactModal from 'react-modal';
import {
  DocumentThumbnail,
  EmailThumbnail,
  WebsiteThumbnail,
  WhiteLabelContent,
  ContactUs,
  PrivacyPage,
  Faqs,
  MarketingOptions,
  InsuranceMarketingOptions,
} from '../../../whitelabel/components';

import './BrokerTheme.scss';
import { bindActionCreators } from 'redux';
import SalesBanner from '../../../whitelabel/components/SalesBanner/SalesBanner';
import VoteBanner from '../../../whitelabel/components/VoteBanner/VoteBanner';
import SendConfig from '../../../whitelabel/components/SenderConfig/SenderConfig';
import { WhiteLabelSummary } from '../../../whitelabel/components/WhiteLabelSummary/WhiteLabelSummary';
import Loader from '../../../../common/components/Loader/Loader';
import LetterFooter from '../../../whitelabel/components/LetterFooter/LetterFooter';
import ThirdPartyScripts from '../../../whitelabel/components/ThirdPartyScripts/ThirdPartyScripts';

const FORM_NAME = 'themeForm';

ReactModal.setAppElement('#app');

class BrokerTheme extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    broker: PropTypes.object.isRequired,
    resource: PropTypes.object.isRequired,
    brokerLabel: PropTypes.object.isRequired,
    formValues: PropTypes.object,
  };

  state = {
    themeConfig: null,
    logo: null,
    editingTheme: false,
    ready: false,
    isDirty: false,
    metadata: null,
    b2cChannel: {},
    contactUsTemplate: null,
    faqTemplate: null,
    uploadType: null,
  };

  form;
  targetOrigin;

  componentWillMount() {
    this.handleSetUpWhitelabel();
  }

  componentDidMount() {
    if (this.targetOrigin) {
      window.removeEventListener('message', this.handleEditorSave);
    }
  }

  handleSetUpWhitelabel = () => {
    const { resource, change, isTrackingLink } = this.props;

    const b2cChannel = getIncludedResource(resource.data, resource.included, 'channel');

    const theme = getIncludedResource(b2cChannel.data, resource.included, 'theme');
    const hasTheme = theme.data.attributes;
    const themeConfig = hasTheme ? theme.data.attributes.config : null;
    const metadata = hasTheme ? theme.data.attributes.metadata : null;
    const hasB2Channel = b2cChannel.data.attributes;
    const logo = hasTheme ? theme.data.attributes.config.urls.logo : null;

    this.setState({
      logo,
      theme,
      themeConfig,
      b2cChannel,
      metadata,
    });

    if (isTrackingLink) {
      const contents = hasB2Channel
        ? getIncludedResource(b2cChannel.data, resource.included, 'contents')
        : null;
      this.getPrivacyPageTemplate(contents, b2cChannel, resource.included);
      this.getContactUsTemplate(contents, b2cChannel, resource.included);
    } else {
      const contents = hasB2Channel
        ? getIncludedResource(b2cChannel.data, resource.included, 'contents')
        : null;
      this.getPrivacyPageTemplate(contents, b2cChannel, resource.included);
      this.getFaqTemplate(contents, b2cChannel, resource.included);
      this.getContactUsTemplate(contents, b2cChannel, resource.included);
    }
    if (hasB2Channel && b2cChannel.data.attributes.metadata?.content) {
      change('meta.whitelabel.content', b2cChannel.data.attributes.metadata?.content);
      change(
        'meta.whitelabel.sms_sender_name',
        b2cChannel.data.attributes.metadata?.sms_sender_name,
      );
      change(
        'meta.whitelabel.sales_banner',
        b2cChannel.data.attributes.metadata?.sales_banner,
      );
      change(
        'meta.whitelabel.vote_banner',
        b2cChannel.data.attributes.metadata?.vote_banner,
      );
      change(
        'meta.whitelabel.letter_footer',
        b2cChannel.data.attributes.metadata?.letter_footer,
      );
      change('meta.whitelabel.marketing', b2cChannel.data.attributes.metadata.marketing);
      change(
        'meta.whitelabel.faq.enabled',
        b2cChannel.data.attributes.metadata?.faq?.enabled,
      );
      change(
        'meta.whitelabel.insurance_marketing_options',
        b2cChannel.data.attributes.metadata.insurance_marketing_options,
      );
      change('meta.whitelabel.sender', b2cChannel.data.attributes.metadata.sender);
      change(
        'meta.whitelabel.cloudfront_enabled',
        b2cChannel.data.attributes.metadata.cloudfront_enabled,
      );
      change('meta.whitelabel.gtm_id', b2cChannel.data.attributes.metadata.gtm_id);
      // change(
      //   'meta.whitelabel.email_content_override',
      //   b2cChannel.data.attributes.metadata?.email_content_override,
      // );
    }
    if (hasB2Channel) {
      const journey = getIncludedResource(b2cChannel.data, resource.included, 'journey');

      if (journey.data.attributes) {
        const directQuote = journey.data.attributes.name === 'Direct Quote';
        change('meta.welcome_page', !directQuote);
      }
    }
  };

  getContactUsTemplate = (contents, b2cChannel, included) => {
    const { actions, change, resource, isTrackingLink } = this.props;
    const resourceName =
      b2cChannel?.data?.attributes?.name ?? resource.data.attributes.name;
    const brokerContactContentName = `${resourceName} Contact Us`;
    const existingContactUs = Array.isArray(contents)
      ? contents.find(
          (content) =>
            content.attributes?.content_type === 'page' &&
            content.attributes.slug === '/contact' &&
            content.attributes.name === brokerContactContentName,
        )
      : null;
    if (!existingContactUs) {
      Promise.resolve(actions.getDefaultContactUs()).then((response) => {
        const contactUsContent = response.data[0];
        const contactUsTemplate = getIncludedResource(
          contactUsContent,
          response.included,
          'template',
        );
        change(
          'meta.contact_us.content.attributes.sections',
          contactUsContent.attributes.sections,
        );
        change('meta.contact_us.content.attributes.name', `${resourceName} Contact Us`);
        change(
          'meta.contact_us.content.relationships.template.data.id',
          contactUsTemplate.data.id,
        );
        change('meta.contact_us.enabled', !isTrackingLink);
        this.setState({
          contactUsTemplate,
        });
      });
    } else {
      const contactUsTemplate = getIncludedResource(
        existingContactUs,
        included,
        'template',
      );
      this.setState({
        contactUsTemplate,
      });
      change('meta.contact_us.content', existingContactUs);
      change('meta.contact_us.enabled', existingContactUs.attributes.status === 'active');
    }
  };

  getPrivacyPageTemplate = (contents, b2cChannel, included) => {
    const { actions, change, resource, isTrackingLink } = this.props;

    const resourceName =
      b2cChannel.data.length > 0
        ? b2cChannel.data.attributes.name
        : resource.data.attributes.name;
    const brokerPrivacyContentName = `${resourceName} Privacy`;
    const existingPrivacyPage = Array.isArray(contents)
      ? contents.find(
          (content) =>
            content.attributes.content_type === 'page' &&
            content.attributes.slug === '/privacy' &&
            content.attributes.name === brokerPrivacyContentName,
        )
      : null;

    if (!existingPrivacyPage) {
      Promise.resolve(
        actions.getDefaultPrivacyPage(
          isTrackingLink ? 'jtc-whitelabel-b2c' : 'aneevo-b2c',
        ),
      ).then((response) => {
        const privacyPageContent = response.data[0];
        const privacyPageTemplate = getIncludedResource(
          privacyPageContent,
          response.included,
          'template',
        );
        change(
          'meta.privacy.content.attributes.sections',
          privacyPageContent.attributes.sections,
        );
        change('meta.privacy.content.attributes.name', brokerPrivacyContentName);
        change(
          'meta.privacy.content.relationships.template.data.id',
          privacyPageTemplate.data.id,
        );
        this.setState({
          privacyPageTemplate,
        });
      });
    } else {
      const privacyPageTemplate = getIncludedResource(
        existingPrivacyPage,
        included,
        'template',
      );
      this.setState({
        privacyPageTemplate,
      });
      change('meta.privacy.content', existingPrivacyPage);
      if (existingPrivacyPage.attributes.name !== brokerPrivacyContentName) {
        change('meta.privacy.content.attributes.name', brokerPrivacyContentName);
      }
    }
  };

  getFaqTemplate = (contents, b2cChannel, included) => {
    const { actions, change, resource } = this.props;
    const existingFaq = Array.isArray(contents)
      ? contents?.find(
          (content) =>
            content.attributes.content_type === 'page' &&
            content.attributes.slug === '/faqs',
        )
      : null;

    if (!existingFaq) {
      const resourceName =
        b2cChannel.data.length > 0
          ? b2cChannel.data.attributes.name
          : resource.data.attributes.name;
      Promise.resolve(actions.getDefaultFaqs()).then((response) => {
        const faqContent = response.data[0];
        const faqTemplate = getIncludedResource(
          faqContent,
          response.included,
          'template',
        );
        change('meta.faq.content.attributes.sections', faqContent.attributes.sections);
        change('meta.faq.content.attributes.name', `${resourceName} Questions`);
        change('meta.faq.content.relationships.template.data.id', faqTemplate.data.id);
        this.setState({
          faqTemplate,
        });
      });
    } else {
      const faqTemplate = getIncludedResource(existingFaq, included, 'template');
      this.setState({
        faqTemplate,
      });
      change('meta.faq.content', existingFaq);
    }
  };

  /*  getEmailTemplates = (contents, b2cChannel) => {
      const { actions, change, resource } = this.props;

      const getEmptyContent = (name, template) => {
        const sections = Object.keys(template.attributes.sections).reduce(
          (carry, sectionKey) => {
            carry[sectionKey] = '';
            return carry;
          },
          {},
        );

        return {
          attributes: {
            content_type: 'email',
            name: name + ' ' + template.attributes.name,
            sections,
          },
          relationships: {
            template: {
              data: {
                id: template.id,
              },
            },
          },
        };
      };

      Promise.resolve(actions.getEmailTemplates()).then((emailTemplates) => {
        this.setState({
          emailTemplates,
        });
        const resourceName =
          b2cChannel.data.length > 0
            ? b2cChannel.data.attributes.name
            : resource.data.attributes.name;
        const emailContent = emailTemplates.map((template) => {
          const matchedContent = contents
            ? contents.find(
                (content) => content.relationships.template.data.id === template.id,
              )
            : null;
          return matchedContent ? matchedContent : getEmptyContent(resourceName, template);
        });
        change('meta.email.content', emailContent);
      });
    };*/

  handleUpdateTheme() {
    const { dispatch, change } = this.props;

    const channel = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'channel',
    );

    if (!channel) {
      return;
    }

    this.setState({
      editingTheme: true,
      ready: false,
      url:
        channel.data.attributes.url +
        '/?embeddable=true&channel=' +
        channel.data.attributes.key +
        '&skipcache=true',
    });

    const theme = getIncludedResource(
      channel.data,
      this.props.resource.included,
      'theme',
    );

    if (!theme) {
      return;
    }

    dispatch(change('data.relationships.theme.data.id', theme.data.id));
  }

  handleUploadComplete(data) {
    const { dispatch, change } = this.props;
    const { uploadType } = this.state;

    if (uploadType === 'logo') {
      dispatch(change('data.relationships.logo_file.data', data.data));
      const newState = {
        logo: data.data.attributes.url,
      };
      if (this.state.themeConfig) {
        newState.themeConfig = {
          ...this.state.themeConfig,
          urls: {
            ...this.state.themeConfig.urls,
            // documentLogo: data.data.attributes.url,
            logo: data.data.attributes.url,
          },
        };
        newState.metadata = {
          simple: {
            ...this.state.metadata?.simple,
            images: {
              ...this.state.metadata?.simple?.images,
              // documentLogo: data.data.attributes.url,
              logo: data.data.attributes.url,
              letterLogo: data.data.attributes.url,
            },
          },
        };
        newState.uploadType = null;
      }
      change('meta.theme.config', newState.themeConfig);
      change('meta.theme.metadata', newState.metadata);
      this.setState(newState);
    }

    if (uploadType === 'banner') {
      dispatch(change('meta.whitelabel.vote_banner.banner', data.data.attributes.url));
    }
  }

  handleUpload = (uploadType) => {
    const { dispatch } = this.props;
    this.setState({
      uploadType,
    });
    dispatch(triggerFileUpload());
  };

  closeEditor = () => {
    this.setState({
      editingTheme: false,
      ready: false,
      url: '',
    });
  };

  handleEditorSave = (event) => {
    if (event.origin !== this.targetOrigin) {
      return;
    }

    const { type, data } = event.data;
    const { dispatch, change } = this.props;

    switch (type) {
      case 'SAVE_THEME':
        this.form = null;
        this.targetOrigin = null;
        window.removeEventListener('message', this.handleEditorSave);

        dispatch(change('meta.theme.config', data.theme));
        dispatch(change('meta.theme.metadata', data.metadata));

        this.setState({
          themeConfig: data.theme,
          metadata: data.metadata,
          isDirty: true,
        });
        this.closeEditor();

        break;
      case 'CLOSE_EDITOR':
        this.closeEditor();
        break;
      default:
        // tslint:disable-next-line:no-console
        console.error(`Unknown postMessage event type of ${event.data.type}`);
    }
  };

  handleOnLoad() {
    const parser = document.createElement('a');
    parser.href = this.state.url;

    const targetOrigin = parser.protocol + '//' + parser.host;
    this.targetOrigin = targetOrigin;

    this.form.contentWindow.postMessage(
      {
        type: 'OPEN_EDITOR',
      },
      targetOrigin,
    );

    if (this.state.metadata) {
      this.form.contentWindow.postMessage(
        {
          type: 'SET_FORM',
          metadata: this.state.metadata,
        },
        targetOrigin,
      );
    }

    this.listener = window.addEventListener('message', this.handleEditorSave);

    this.setState({
      ready: true,
    });
  }

  handleFormSubmit = (values) => {
    const { actions, brokerId } = this.props;

    Promise.resolve(actions.createWhiteLabel(brokerId, values))
      .then(() => {
        return actions.getBroker(brokerId);
      })
      .then(() => {
        this.setState({ isDirty: false });
        this.handleSetUpWhitelabel();
      });
  };

  renderModal() {
    const { editingTheme, ready, url } = this.state;

    return (
      <SimpleModal
        className="whitelabel-modal"
        isOpen={editingTheme}
        onRequestClose={this.closeEditor}
      >
        <div className={'whitelabel__editor'}>
          <h1>Whitelabel Editor</h1>

          <div className={'whitelabel__editor__viewport'}>
            <div className={ready ? 'hidden' : 'whitelabel__editor__viewport__loader'}>
              <h3>Loading Editor</h3>

              <span className="loader-dots">
                <i className="fa fa-circle loader-dot" />
                <i className="fa fa-circle loader-dot" />
                <i className="fa fa-circle loader-dot" />
              </span>
            </div>

            <iframe
              ref={(ref) => (this.form = ref)}
              src={url}
              className={'whitelabel__editor__iframe' + (ready ? '' : ' hidden')}
              onLoad={::this.handleOnLoad}
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  buttons() {
    const { isSubmitting } = this.props;
    const channelData = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'channel',
    );
    const channel = channelData.data.attributes !== undefined;

    const themeButtons = [
      {
        render: true,
        permissions: ['broker.edit'],
        button: (
          <Button
            key={'wl'}
            className="pull-right"
            type="submit"
            bsStyle="primary"
            disabled={isSubmitting}
            isLoading={isSubmitting}
            label={(channel ? 'Save' : 'Create') + ' White Label'}
          />
        ),
      },
      {
        render: channel,
        permissions: ['broker.edit'],
        button: (
          <Button
            key={'theme'}
            className="pull-right"
            bsStyle="primary"
            handleClick={::this.handleUpdateTheme}
            disabled={isSubmitting}
            label="Update Theme"
          />
        ),
      },
      {
        render: true,
        permissions: ['broker.edit'],
        button: (
          <Button
            key={'logo'}
            className="pull-right"
            bsStyle="primary"
            handleClick={() => this.handleUpload('logo')}
            label={(this.state.logo ? 'Replace' : 'Upload') + ' Logo'}
            disabled={isSubmitting}
            rightIcon="image"
          />
        ),
      },
      {
        render: true,
        permissions: ['marketing.source_view'],
        button: (
          <Button
            key={'channel'}
            label="View Channel"
            className="pull-right"
            bsStyle="primary"
            disabled={isSubmitting}
            link
            to={'/admin/channels/' + channelData.data.id}
          />
        ),
      },
    ];

    return themeButtons.filter((button) => {
      return button.render;
    });
  }

  customDomain = () => {
    const { dispatch, change } = this.props;
    dispatch(change('meta.url', ''));
  };

  render() {
    const { formValues, handleSubmit, isTrackingLink } = this.props;
    const {
      isDirty,
      themeConfig,
      // emailTemplates,
      contactUsTemplate,
      privacyPageTemplate,
      faqTemplate,
      uploadType,
    } = this.state;
    const channel = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'channel',
    );
    const hasWhiteLabel = channel.data.attributes !== undefined;

    const renderWarning = () => {
      if (!isDirty) {
        return null;
      }

      return (
        <Alert bsStyle="warning" className="text-center">
          YOU HAVE UNSAVED STYLE CHANGES
        </Alert>
      );
    };

    if (!formValues) {
      return <Loader />;
    }

    return (
      <React.Fragment>
        {this.renderModal()}
        <>
          {renderWarning()}

          <Form onSubmit={handleSubmit(this.handleFormSubmit)}>
            <Row>
              <Col sm={7}>
                <Col sm={3}>
                  <ControlLabel>Logo</ControlLabel>
                </Col>
                <Col sm={8}>
                  <div className="broker-logo-container">
                    {this.state.logo ? (
                      <img alt="logo" src={this.state.logo} />
                    ) : (
                      <h3 className="text-center">No Logo</h3>
                    )}
                  </div>
                </Col>
              </Col>
              <Col sm={5}>
                {hasWhiteLabel && (
                  <>
                    <InfoLabel
                      label="Status"
                      labelSize={4}
                      value={channel.data.attributes.status}
                    />
                    <InfoLabel
                      label="URL"
                      labelSize={4}
                      isLowerCase
                      value={
                        <Link
                          to={channel.data.attributes.url + '?skipcache=true'}
                          target="_blank"
                          onlyActiveOnIndex
                        >
                          {channel.data.attributes.url}
                        </Link>
                      }
                    />
                    <InfoLabel
                      label="Created"
                      labelSize={4}
                      dateTime
                      value={channel.data.attributes.created_at}
                    />
                    <InfoLabel
                      label="Updated"
                      labelSize={4}
                      dateTime
                      value={channel.data.attributes.updated_at}
                    />
                  </>
                )}
                <WhiteLabelSummary
                  hasWhiteLabel={hasWhiteLabel}
                  customDomain={get(formValues, 'meta.custom_domain')}
                  isTrackingLink={isTrackingLink}
                />
              </Col>
            </Row>
            {themeConfig && formValues && (
              <div>
                <div className="hr" />
                <Row>
                  <Col lg={4}>
                    <WebsiteThumbnail
                      theme={themeConfig}
                      phone={
                        formValues?.meta?.whitelabel?.content?.telephone_number ??
                        channel?.data?.attributes?.metadata?.content?.telephone_number ??
                        ''
                      }
                      openingHours={
                        formValues?.meta?.whitelabel?.content?.opening_hours ??
                        channel?.data?.attributes?.metadata?.content?.opening_hours ??
                        ''
                      }
                      salesBanner={
                        formValues?.meta?.whitelabel?.sales_banner ??
                        channel?.data?.attributes?.metadata?.sales_banner ??
                        ''
                      }
                      footer={
                        formValues?.meta?.whitelabel?.content?.footer ??
                        channel.data.attributes.metadata?.content?.footer ??
                        ''
                      }
                    />
                  </Col>
                  <Col lg={4}>
                    <EmailThumbnail
                      theme={themeConfig}
                      phone={
                        formValues?.meta?.whitelabel?.content?.telephone_number ??
                        channel?.data?.attributes?.metadata?.content?.telephone_number ??
                        ''
                      }
                      footer={
                        formValues?.meta?.whitelabel?.content?.footer ??
                        channel.data.attributes.metadata?.content?.footer ??
                        ''
                      }
                    />
                  </Col>
                  <Col lg={4}>
                    <DocumentThumbnail theme={themeConfig} />
                  </Col>
                </Row>
              </div>
            )}

            <div className="hr" />

            <WhiteLabelContent show={hasWhiteLabel} />
            <SendConfig />
            <SalesBanner enabled={formValues?.meta?.whitelabel?.sales_banner?.enabled} />
            <VoteBanner
              enabled={formValues?.meta?.whitelabel?.vote_banner?.enabled}
              handleOpenUpload={this.handleUpload}
            />
            <MarketingOptions
              enabled={formValues?.meta?.whitelabel?.marketing?.enabled}
            />
            <InsuranceMarketingOptions
              enabled={formValues?.meta?.whitelabel?.insurance_marketing_options?.enabled}
            />
            <ContactUs
              enabled={formValues.meta.contact_us && formValues.meta.contact_us.enabled}
              template={contactUsTemplate}
            />
            {!isTrackingLink && (
              <>
                <Faqs
                  template={faqTemplate}
                  isEnabled={formValues?.meta?.whitelabel?.faq?.enabled}
                />
                <LetterFooter show={hasWhiteLabel} />
              </>
            )}

            <PrivacyPage template={privacyPageTemplate} />
            <ThirdPartyScripts />
            {renderWarning()}
            <UploadCropComponent
              onComplete={::this.handleUploadComplete}
              width={uploadType === 'banner' ? 655 : 355}
              height={238}
              bsSize="lg"
              circle={false}
              minScale={30}
            />

            <Row>
              <Col sm={12}>
                <InternalButtonBar buttons={this.buttons()} />
              </Col>
            </Row>
          </Form>
        </>
      </React.Fragment>
    );
  }
}

const form = reduxForm({ form: FORM_NAME })(BrokerTheme);
export default connect(
  (state) => {
    return {
      initialValues: {
        meta: {
          custom_domain: false,
          url: '',
          theme: null,
          whitelabel: {
            sales_banner: {
              enabled: false,
            },
            vote_banner: {
              enabled: false,
            },
            marketing: {
              enabled: false,
            },
            insurance_marketing_options: {
              enabled: false,
            },
            gtm_id: '',
            cloudfront_enabled: false,
          },
          faq: {
            enabled: false,
          },
          contact_us: {
            enabled: false,
          },
        },
      },
      formValues: getFormValues(FORM_NAME)(state),
      isSubmitting: state.broker.isSubmitting,
    };
  },
  (dispatch) => ({
    channelActions: bindActionCreators(channelActions, dispatch),
    actions: bindActionCreators(actions, dispatch),
  }),
)(form);
